import { render, staticRenderFns } from "./inputTitle.vue?vue&type=template&id=1fff1c6e&lang=pug&"
import script from "./inputTitle.vue?vue&type=script&setup=true&lang=js&"
export * from "./inputTitle.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports